import { render, staticRenderFns } from "./NavigationPublisherList.vue?vue&type=template&id=663b2936&"
import script from "./NavigationPublisherList.vue?vue&type=script&lang=js&"
export * from "./NavigationPublisherList.vue?vue&type=script&lang=js&"
import style0 from "./NavigationPublisherList.vue?vue&type=style&index=0&id=663b2936&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports